import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonComponent } from '../../ui/button/button.component';
import { IdleService } from '../../../../core/services/idle.service';

/**
 * Hallmark · component: idle warning · genre: modern-minimal
 * states: hidden · shown · countdown · dismissed · expired
 * contrast: pass
 *
 * Modal shown after inactivity; the user resumes or logs out before the
 * countdown reaches zero.
 */
@Component({
  selector: 'app-idle-warning',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent],
  template: `
    @if (idle.warning()) {
      <div class="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 px-4 backdrop-blur-sm"
           role="alertdialog" aria-modal="true" aria-labelledby="idle-title">
        <div class="w-full max-w-sm rounded-2xl border border-[var(--color-surface-border)] bg-[var(--color-surface-raised)] p-6 shadow-2xl">
          <div class="flex items-start gap-3">
            <span class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[var(--color-warning)]/10 text-[var(--color-warning)]">
              <i class="fa-regular fa-clock"></i>
            </span>
            <div class="min-w-0">
              <h2 id="idle-title" class="text-base font-semibold text-[var(--color-text-primary)]">Sesi akan berakhir</h2>
              <p class="mt-1 text-sm leading-relaxed text-[var(--color-text-muted)]">
                Tidak ada aktivitas terdeteksi. Anda akan keluar otomatis dalam
              </p>
            </div>
          </div>

          <!-- Countdown -->
          <div class="mt-4 flex items-baseline gap-1">
            <span class="text-3xl font-bold tabular-nums text-[var(--color-warning)]">{{ idle.secondsLeft() }}</span>
            <span class="text-sm text-[var(--color-text-muted)]">detik</span>
          </div>
          <div class="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-[var(--color-surface-border)]">
            <div class="h-full rounded-full bg-[var(--color-warning)] transition-[width] duration-1000 ease-linear"
                 [style.width.%]="(idle.secondsLeft() / 60) * 100"></div>
          </div>

          <div class="mt-5 flex flex-col gap-2 sm:flex-row">
            <app-button variant="primary" size="md" class="flex-1" (click)="idle.resume()">
              <i class="fa-solid fa-play mr-1.5"></i>Lanjutkan sesi
            </app-button>
            <app-button variant="ghost" size="md" class="flex-1" (click)="idle.logout()">
              <i class="fa-solid fa-right-from-bracket mr-1.5"></i>Keluar
            </app-button>
          </div>
        </div>
      </div>
    }
  `,
})
export class IdleWarningComponent {
  readonly idle = inject(IdleService);
}
